import clsx from "clsx";

import { PRICING_PLANS } from "features/subscriptions/constants";

type IconSize = "sm" | "md" | "lg";

const colorClassName: Record<keyof typeof PRICING_PLANS, string[]> = {
  agency: [
    "[box-shadow:0_0_1.667px_1.667px_rgba(255,255,255,0.16)_inset,0_0_0_2px_rgba(243,244,246,0.50),0_23.333px_16.667px_0_rgba(224,229,255,0.70),0_23.333px_16.667px_0_rgba(85,116,255,0.10),0_11.667px_8.333px_0_rgba(119,85,255,0.10)]",
  ],
  user: [
    "[box-shadow:0_0_1.667px_1.667px_rgba(255,255,255,0.16)_inset,0_0_0_2px_rgba(246,244,243,0.80),0_11.667px_11.667px_0_rgba(255,142,66,0.20)]",
  ],
  rental: [
    "[box-shadow:0_0_1.667px_1.667px_rgba(255,255,255,0.16)_inset,0_2.5px_5px_1.667px_rgba(17,24,39,0.20),0_0_0_2px_rgba(243,244,246,0.50),0_23.333px_16.667px_0_rgba(224,225,255,0.70)]",
  ],
};

const containerSizeMap: Record<IconSize, string> = {
  sm: "size-10",
  md: "size-12",
  lg: "size-14",
};

const iconSizeMap: Record<IconSize, string> = {
  sm: "size-5",
  md: "size-6",
  lg: "size-7",
};

export default function SubscriptionPlanIcon({
  size,
  plan,
}: {
  size: IconSize;
  plan: keyof typeof PRICING_PLANS;
}) {
  const { icon: Icon } = PRICING_PLANS[plan];

  return (
    <Icon
      className={clsx(
        iconSizeMap[size],
        containerSizeMap[size],
        colorClassName[plan],
        "rounded-2xl",
      )}
    />
  );
}
